<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
      <template slot="categories" slot-scope="row">
      <div v-if="row.item.categories">
        <span
          v-for="category in row.item.categories"
          :key="category.id"
          class="tag"
        >
          {{ category.name }}
        </span>
      </div>
    </template>
      <template slot="price" slot-scope="row">
        {{ row.item.base_price_list_item.price | currency }} €
    </template>
      <template slot="vat" slot-scope="row">
        {{ row.item.vat | currency }} %
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as PRODUCT_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'ProductTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'categories',
          label: this.$t('Product categories'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'unit',
          label: this.$t('Unit type'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'unit_name'
        },
        {
          key: 'price',
          label: this.$t('Price'),
          type: 'text',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: false,
          custom: true
        },
        {
          key: 'vat',
          label: this.$t('VAT'),
          type: 'text',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
          custom: true
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'note']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: PRODUCT_TYPES.GENERIC.product.product.LIST.GETTERS.selectAll,
      selectedList: PRODUCT_TYPES.GENERIC.product.product.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('product_product_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: PRODUCT_TYPES.GENERIC.product.product.LIST.MUTATIONS.setList,
      setSelectedList:
        PRODUCT_TYPES.GENERIC.product.product.LIST.MUTATIONS.setSelectedList,
      setSelectAll: PRODUCT_TYPES.GENERIC.product.product.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...PRODUCT_TYPES.GENERIC.product.product.LIST.ACTIONS
    })
  }
}
</script>
